import { gql } from '@apollo/client';

export const GET_PERSON = gql`
  query User($personId: Int!) {
    user(personId: $personId) {
      id
      photoUrl
      isBeingViewedByBuddy
      buddies {
          id
          name
          photoUrl
      }
      currentCourseAttendances {
        attendance {
            id
            status
        }
        courseId
        course {
            id
            name
            SKU
        }
      }
      isArchived
      scriptName
      canEditPhone
      haveRegistrationDocument
      registrationDocumentUrl
      # Social workers reach a person through this view, not the admin one, and the brief
      # names them alongside centre managers as the people who should see this paperwork.
      # Gated server-side: a plain teacher gets an empty list and so no section at all.
      supportingDocuments {
        id
        kind
        fileName
        createdAt
        url
      }
      preferredName
      identifier
      name
      dob
      address
      attendancePercentage
      truency
      picturePermission
      coursesTeaching {
        id
        name
        SKU
      }
      courses {
        id
        name
        SKU
      }
    }
  }
`;
